<!--
 * @Author: cgh
 * @Date: 2022-08-03 19:05:08
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:56:51
 * @Description: 查看评估仪器
-->
<template>
  <!-- 页面头部 Start -->

  <!-- 页面头部 End -->
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-70 o-dialog-h--75"
    title="评估仪器"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      class="l-page l-page--search"
    >
      <!-- 页面主内容：查询列表 Start -->
      <div
        class="l-page__body l-page--search__body"
      >
        <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
        <!-- table的ref的命名根据业务名称修改 -->
        <k-table
          v-if="dlTypeFlag"
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="pgyqList.rows"
          :pagination="pgyqList"
          :pagination-show="true"
          multiple
          @current-change="init"
          @size-change="handleSizeChange"
          @selection-change="handleSelectionChange"
        />
        <k-table
          v-else
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="xmPgywList"
          :pagination-show="false"
          @current-change="init"
        />
      </div>
    </div>
    <!-- -->
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="dlTypeFlag"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgxmManageService } from '../pgxm.service.js';
import { pgyqManageService } from '@/features/xfaqpg/pgyqgl/pgyq.service.js';
export default {
  name: 'PgyqDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      xmid: null,
      loading: false, // 页面是否加载
      tableColumn: [
        { key: 'sbmc', label: '设备名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'sbbh', label: '设备编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jyzjbh', label: '检定/校准证书编号', align: 'left', minWidth: '80', type: 'text' },
        { key: 'yxq', label: '有效期', align: 'left', minWidth: '80', type: 'date' }
      ],
      fd: {
        yqIdList: []
      },
      // 查询条件
      filterParams: {
        sfqy: 'Y',
        xmId: null
      },
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */
      multipleSelectedRow: [], // 表格选中行（多选）
      pgyqList: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      xmPgywList: []

    };
  },
  computed: {
    dlTypeFlag () {
      return this.dlParams.type === 'edit';
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.init();
    },
    /**
     * @description: 保存操作
     * @return {*}
     */
    handleSave () {
      // this.loading = true;
      // 遍历复选中选框内容，取评估仪器id
      this.fd.yqIdList = [];
      for (const key in this.multipleSelectedRow) {
        this.fd.yqIdList.push(this.multipleSelectedRow[key].id);
      }
      console.log(this.fd.yqIdList);
      pgxmManageService.updatePgyq(this.xmid, this.fd.yqIdList)
        .then(rsp => {
          this.$alert('保存成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          this.loading = false;
          console.error('保存评估仪器错误！', err);
        });
    },
    /**
     * 初始化数据
     */
    init () {
      const _this = this;
      _this.loading = true;
      _this.trueFilterParams = JSON.parse(JSON.stringify(_this.filterParams));
      pgyqManageService.query(_this.trueFilterParams)
        .then(rsp => {
          _this.pgyqList = Object.assign({}, _this.pgyqList, rsp.data);
          _this.getPgxmInfoPgyq();
        })
        .catch(err => {
          console.error('评估仪器信息查询错误', err);
        })
        .finally(() => {
          // _this.loading = false;
        });
    },
    /**
     * 项目仪器初始化赋值
     */
    getPgxmInfoPgyq () {
      const _this = this;
      _this.loading = true;
      pgxmManageService.pgyqByXmid(_this.xmid)
        .then(rsp => {
          if (rsp.data.length <= 0) return;
          // 该项目的已存在的评估仪器
          const _yqList = [];
          rsp.data.forEach(item => {
            const equalList = _this.pgyqList.rows.filter(_item => _item.id === item.id);
            if (this.dlTypeFlag) {
              // 编辑时候多选框显示数据
              _yqList.push(equalList[0]);
            } else {
              // 查看详情页面显示该项目下的评估仪器数据
              this.xmPgywList.push(equalList[0]);
            }
          });
          _this.$nextTick(() => {
            _this.toggleSelection(_yqList);
          });
        })
        .catch(err => {
          console.error('该项目的评估仪器信息查询错误', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * 初始项目选中的评估仪器
     */
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.kTable.toggleRowSelection(row);
        });
      }
    }
  },
  created () {
    this.xmid = this.dlParams.id;
    this.filterParams.xmId = this.dlParams.id;
    this.init();
    // 获取该窗口是否是在编辑页面打开
    if (!this.dlTypeFlag) {
      // 在列表头部添加序号
      this.tableColumn.unshift({ key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' });
    }
  }
};

</script>
